<template>
    <div>
        <!-- Button trigger -->
        <a v-popover:popover4 class="pointer">
            <slot name="triggerbutton">trigger</slot>
        </a>
        <el-popover
            ref="popover4"
            placement="right"
            transition=""
            popper-class="listing-dropdown"
            trigger="hover">
                <slot name="content">No data</slot>
                <slot name="actionbuttons"></slot>
        </el-popover>

    </div>
</template>

<script>
    export default{
        props: [],
        data(){
            return {

            }
        },
        methods: {
           
        }
    }
</script>